export enum BestMethodToContact {
  'Phone' = 0,
  'Text' = 3,
  'Email' = 2,
}
